import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useCookie} from '@aboutyou/storage';
import {GENDER_COOKIE_KEY} from '@aboutyou/utils';
import {startTransition, useEffect} from 'react';

export type SessionGender = 'female' | 'kids' | 'male';

const transformRawValue = (raw?: string): SessionGender | undefined => {
  if (raw === 'female' || raw === 'male' || raw === 'kids') {
    return raw;
  }
  return undefined;
};

export const useSessionGender = () => {
  const [gender, updateGender] = useCookie<SessionGender | undefined>({
    cookieName: GENDER_COOKIE_KEY,
    transformRawValue,
    defaultValue: undefined,
  });

  useEffect(() => {
    startTransition(() => {
      if (
        window.clientState &&
        window.clientState.getCurrent().shopGender !== gender
      ) {
        window.clientState.update({shopGender: gender});
      }
    });
  }, [gender]);

  return {
    gender,
    updateGender,
  };
};

export const useUpdateSessionGender = (
  nextGender: SessionGender | undefined,
) => {
  const {updateGender} = useSessionGender();
  const isHydrationDone = useHydrationDone();

  useEffect(() => {
    if (nextGender && isHydrationDone) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
      updateGender(nextGender);
    }
    // do not include updateGender in the dependency array,
    // including it would cause the components where `useUpdateSessionGender` is used to rerender, which has side effects like unwanted gender set after a desired one is set explicitly
  }, [nextGender, isHydrationDone]);
};
